// Types
import { ChangeEvent } from 'react';
import { MemorabiliaProductType } from 'api/graphql-global-types';
import { GetMemorabilia_getMemorabilia_filters_types } from 'api/memorabilia/types/GetMemorabilia';
// Context
import { useFiltersContext } from 'components/common3/PageWithFiltersWrapper/PageWithFiltersContext';
// Components
import CheckboxFilter from 'components/common3/PageWithFiltersWrapper/components/Filters/components/CheckboxFilter/CheckboxFilter';

type ProductTypeFilterProps = {
  availableOptions: GetMemorabilia_getMemorabilia_filters_types[];
};

const MEMORABILIA_OPTION: GetMemorabilia_getMemorabilia_filters_types = {
  __typename: 'MemorabiliaTypeFilter',
  name: MemorabiliaProductType.Memorabilia,
};

export const MemorabiliaProductTypeFilter = ({
  availableOptions,
}: ProductTypeFilterProps) => {
  const { filters, setFilters } = useFiltersContext();

  const hasMemorabiliaOption = availableOptions.some(
    (option) =>
      option.name === MemorabiliaProductType.Memorabilia ||
      option.name === MemorabiliaProductType.Product
  );

  const onCheckBoxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const productType = e.target.checked
      ? [MemorabiliaProductType.Memorabilia, MemorabiliaProductType.Product]
      : [];

    setFilters({ ...filters, productType });
  };

  const isFilterActive = Boolean(filters?.productType?.length);

  if (!hasMemorabiliaOption) {
    return null;
  }

  return (
    <CheckboxFilter<GetMemorabilia_getMemorabilia_filters_types>
      title="Product Type"
      options={[MEMORABILIA_OPTION]}
      // Both Memorabilia and legacy Product filter values map to this single
      // checkbox, so normalize any non-empty productType to the checkbox's
      // own value - otherwise a URL/state carrying only `['Product']` (e.g.
      // an old bookmarked link) would filter the list but show unchecked.
      selectedValues={
        isFilterActive ? [MemorabiliaProductType.Memorabilia] : []
      }
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.name}
      onChange={onCheckBoxChange}
      isOpen={isFilterActive}
    />
  );
};

export default MemorabiliaProductTypeFilter;
